export default __webpack_public_path__ + "static/Creative_Comm_benefit_1-fa11d8dac3ed9f8045d8792de21ceba2.svg";